const getSettings = () => {
    // Internal links must always stay on the origin that serves the app.
    // The development server can run on a different port when 3000 is busy.
    return { PUBLIC_URL: window.location.origin };
};

export const HOST = {
    PUBLIC_URL: getSettings().PUBLIC_URL,
}
